import MapHome from "../modules/MapHome";
import VanillaModal from "vanilla-modal";
import $ from "jquery";

export default {
  init() {
    $.getJSON("?view=ajax/dealer-list", function(data) {
      const markers = data.map(m => ({
        ...m,
        position: {
          lat: parseFloat(m.position.lat, 10),
          lng: parseFloat(m.position.lng, 10)
        }
      }));
      MapHome(markers);
    });
  },
  finalize() {
    const modalNode = document.createElement("div");
    modalNode.setAttribute("id", "modal-displayContent");
    modalNode.style.display = "none";
    document.body.appendChild(modalNode);

    const modal = new VanillaModal();

    $(".Footer a").on("click", function(e) {
      e.preventDefault();
      const link = $(this).attr("href");
      const targetContent = $(this).data("target");

      window.location.href = "/hub-contact";
    });
  }
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/home.js